import { render } from "./qualifications.vue?vue&type=template&id=3e5d9138"
import script from "./qualifications.vue?vue&type=script&lang=js"
export * from "./qualifications.vue?vue&type=script&lang=js"

import "./qualifications.vue?vue&type=style&index=0&id=3e5d9138&lang=less"

import exportComponent from "D:\\wwwroot\\tutoredin\\online-education\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__